import { forwardRef } from "react";
import Link from "@material-ui/core/Link";

const link = forwardRef(({ children, ...otherProps }, ref) => {
  return <Link color="secondary" {...otherProps}>{children}</Link>;
});

export default link